import { useEffect, useState } from "react";
import { AlertTriangle, RefreshCw, X } from "lucide-react";

/**
 * Bannière d'incident globale.
 * S'affiche automatiquement quand une requête GET /api renvoie une erreur
 * réseau ou 5xx persistante (après 2 tentatives automatiques).
 * L'utilisateur peut fermer la bannière ou relancer la page.
 */
export default function OfflineBanner() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onOffline = () => { setVisible(true); setDismissed(false); };
    const onOnline = () => setVisible(false);
    window.addEventListener("api:offline", onOffline);
    window.addEventListener("api:online", onOnline);
    return () => {
      window.removeEventListener("api:offline", onOffline);
      window.removeEventListener("api:online", onOnline);
    };
  }, []);

  if (!visible || dismissed) return null;

  return (
    <div
      className="fixed inset-x-0 top-0 z-[100] pointer-events-none flex justify-center px-4 pt-3"
      data-testid="offline-banner"
    >
      <div className="pointer-events-auto max-w-3xl w-full bg-[#B91C1C] text-white shadow-2xl rounded-sm border border-white/10 overflow-hidden">
        <div className="flex items-start gap-3 px-4 py-3 sm:px-5 sm:py-3.5">
          <div className="mt-0.5 shrink-0">
            <AlertTriangle className="w-5 h-5" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold leading-snug">
              Connexion au serveur momentanément indisponible
            </p>
            <p className="text-xs text-white/85 mt-0.5 leading-relaxed">
              Certaines actualités ou données peuvent ne pas s'afficher. Nous réessayons automatiquement — vous pouvez aussi relancer la page.
            </p>
          </div>
          <button
            onClick={() => window.location.reload()}
            className="shrink-0 inline-flex items-center gap-1.5 text-xs font-semibold bg-white/15 hover:bg-white/25 px-3 py-1.5 rounded-sm transition-colors"
            data-testid="offline-banner-reload"
          >
            <RefreshCw className="w-3.5 h-3.5" /> Réessayer
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="shrink-0 text-white/75 hover:text-white p-1 -m-1"
            aria-label="Fermer"
            data-testid="offline-banner-dismiss"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
